'use client'

import React from 'react'

import * as UI from './form-fields.styled'

export type PersonalFieldsData = {
  name: string
  last_name: string
  second_name: string
}

export interface Props {
  className?: string
}

export const PersonalFields = (props: Props) => {
  return (
    <UI.Wrapper className={props.className}>
      <UI.Input name="last_name" placeholder="Фамилия" required>
        Фамилия
      </UI.Input>

      <UI.Input name="name" placeholder="Имя" required>
        Имя
      </UI.Input>

      <UI.Input name="second_name" placeholder="Отчество">
        Отчество
      </UI.Input>
    </UI.Wrapper>
  )
}
